





















import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  props: {
    value: Boolean
  }
})
export default class ReservationFailDialog extends Vue {
  private closeDialog(): void {
    this.$emit("input", false);
  }
}
